import { render, staticRenderFns } from "./ChangeMail.vue?vue&type=template&id=60003100&lang=pug"
import script from "./ChangeMail.vue?vue&type=script&lang=js"
export * from "./ChangeMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports